const fixtureTypes = {
  /**
   * FIXTURE family
   *
   * Moving heads
   */
  HEAD: 0,
  /**
   * FIXTURE family
   *
   * Scanners
   */
  SCAN: 1,
  /**
   * FIXTURE family
   *
   * Color scroller & PARs
   */
  TRAD: 2,
  /**
   * FIXTURE family
   *
   * LED fixtures
   */
  LED: 3,
  /**
   * FIXTURE family
   *
   * Rollers
   */
  ROLLER: 4,
  /**
   * FIXTURE family
   *
   * Other kind of fixtures
   */
  MULTI: 5,
  /**
   * OBJECT family
   *
   * Panels
   */
  PANEL: 6,
  /**
   * OBJECT family
   *
   * Other shapes
   */
  OBJECT: 7,
  /**
   * LASER family
   *
   * Laser fixtures
   */
  LASER: 8,
  /**
   * OTHER family
   *
   * Smoke machines & hazers
   */
  SMOKE: 9,
}

export default fixtureTypes
